import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { PurchasingAssistantBubble } from '@/components/purchasing/PurchasingAssistantBubble';

interface DashboardLayoutProps {
  header?: ReactNode;
  children: ReactNode;
  fullWidth?: boolean;
}

export function DashboardLayout({ header, children, fullWidth }: DashboardLayoutProps) {
  return (
    <div className="flex flex-col h-full w-full">
      <header className="sticky top-0 z-10 border-b border-border/40 bg-background/80 backdrop-blur-md supports-[backdrop-filter]:bg-background/60 shrink-0">
        {/* Lightspeed-style accent bar at top */}
        <div className="h-1 w-full bg-gradient-to-r from-primary via-primary to-primary/70" />
        <div className="flex h-[68px] items-center">
          <div className="container mx-auto px-6">
            {header}
          </div>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto overflow-x-hidden bg-muted/10 [scrollbar-gutter:stable]">
        <div className={cn(
          "py-8 min-w-0",
          fullWidth ? "px-6" : "container mx-auto px-6"
        )}>
          {children}
        </div>
      </main>
      <PurchasingAssistantBubble />
    </div>
  );
}
